const dateTimeServiceName = "/DateTime";

export function dateTimeService(http) {
    return {        
        getYearMonthLists: (yearRange) => {
            return http.post(dateTimeServiceName + "/GetYearMonthLists", { Years: yearRange});
        },
    }
}
